import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  max-width: 1400px;
  margin: 1.4rem auto;
  gap: 1rem;

  @media (max-width: 720px) { 
    width: 128%;
    display: flex;
    justify-content: flex-start;
    gap: 0;
  }
`;
